import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import {
    OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {
    ADD_AND_OPEN_CLIENT_BY_USERNAME,
    AddAndOpenClientByUsernamePayloadInterface,
    NEW_HAVE_NO_ANSWER_CLIENT,
    OperatorApplicationEventManager,
    SCROLL_TO_USERNAME_IN_BUDDY_LIST
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {__} from "~/ts/library/Translate";
import playNotificationSoundAboutClientMessage
    from "~/operatorApplication/ts/service/dialog/PlayNotificationSoundAboutClientMessage";
import Delay from "~/ts/library/Delay";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {BuddyListOptionWithIcon} from "~/operatorApplication/vue/dialogs/buddyList/group/BuddyListInterface";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {ref, Ref} from "vue";
import {
    SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME,
    ScrollToClientMessageByIdPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {getFirstMessageIdByDialog} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/goToDialog";


export default class OperatorApplicationBuddyList {
    public static lastRemovedClient: Ref<{
        username: string,
        time: number
    }> = ref();

    public static async removeClientWithConfirmation(username: string) {
        if (OperatorApplicationConfigInstance.confirmOnRemoveFromBuddyList) {
            try {
                await ElConfirm(__("Вы уверены, что хотите удалить этого клиента из списка ваших контактов? Его можно будет вернуть, найдя диалог через поиск."));
            } catch (e) {
                return;
            }
        }
        OperatorApplicationBuddyList.removeClients([username]);
        try {
            await Delay.make(200, "removeClientWithConfirmation", true);
            this.lastRemovedClient.value = {
                username,
                time: Date.now()
            };
        } catch (e) {

        }
    }

    public static async removeClients(usernames: string[], operatorIds?: string[]) {
        for (let username of usernames) {
            OperatorAccountStore.removeClientFromBuddyList(username);
        }
        let p: OperatorApplicationApi.OperatorRemoveFromBuddyListOpenApiModel = {
            usernames,
            operatorIds
        };
        let result: OpenApiResult<any>;
        try {
            result = await (new OperatorApiRequest({
                url: "/buddyList/removeFromBuddyList",
                p,
                silent: true,
                silentError: true
            })).send();
        } catch (e) {

        }

        if (!operatorIds) {
            if (result && !result.showMessageOnError()) {
                usernames = (result.data as OperatorApplicationApi.OperatorRemoveFromBuddyListResultOpenApiModel).keepUsernames;
            }
            for (let username of usernames) {
                OperatorAccountStore.addClientToBuddyList(username);
            }
        } else {
            result?.showMessageOnError();
        }

        return result;
    }

    public static async addClientAndOpenByUserdata(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, messageId?: number) {
        await this.addClientAndOpen(client.username, client, messageId);
    }

    public static async addClientAndOpenByUsername(username: string, messageId?: number, dialogId?: number) {
        await this.addClientAndOpen(username, null, messageId, dialogId);
    }

    public static scrollToClientMessageByIdPayload: ScrollToClientMessageByIdPayloadInterface;

    public static async scrollToDialogId(username: string, dialogId?: number, messageId?: number) {
        if (!messageId && dialogId) {
            messageId = await getFirstMessageIdByDialog(username, dialogId);
        }
        if (messageId) {
            let p: ScrollToClientMessageByIdPayloadInterface = {
                messageId,
                username
            };
            this.scrollToClientMessageByIdPayload = p;
            OperatorApplicationEventManager.emit(SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME, p);
        }
    }

    private static async addClientAndOpen(
        username: string,
        client?: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
        messageId?: number,
        dialogId?: number
    ) {
        if (!ClientUserdataStore.getByUsername(username)) {
            if (client) {
                this.openClientByUserdata(client)
            } else {
                this.openClientByUsername(username);
            }
        } else {
            this.openClientByUsername(username);
        }

        await this.addClients([username]);
        this.scrollToUsernameInBuddyList(username);
        await this.scrollToDialogId(username, dialogId, messageId);
    }

    public static async addClients(usernames: string[]) {
        let p: OperatorApplicationApi.OperatorAddToBuddyListOpenApiModel = {
            usernames
        };
        return await (new OperatorApiRequest({
            url: "/buddyList/addToBuddyList",
            p,
            silent: true,
            silentError: true
        })).send()
    }

    public static async openClientByUsername(username: string) {
        let client = await ClientUserdataStore.getByUsernameAsync(username);
        if (client) {
            try {
                ClientUserdataStore.readMessages({username: client.username});

                await this.routeToClient(client);

            } catch (e) {

            }
        }
    }

    private static scrollToUsernameInBuddyList(username: string, timeout: number = 500) {
        setTimeout(() => {
            OperatorApplicationEventManager.emit(SCROLL_TO_USERNAME_IN_BUDDY_LIST, username);
        }, timeout);
    }

    private static routeToClient(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
        let buddyListId = OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN;
        if (client.type.isCrossOperatorsChat) {
            let buddyList = OperatorAccountStore.data.value.buddyListConfig.find(item => item.isCrossOperatorsChat);
            if (buddyList) {
                buddyListId = buddyList.id;
            } else {
                return;
            }
        } else if (client.type.isCrossOperatorsConversationChat) {
            return;
        }
        OperatorApplicationRoutingStore.openDialogsByBuddyListId(buddyListId);
        OperatorApplicationDialogsStore.setSelectedUsername({
            buddyListId,
            username: client.username
        });
        this.scrollToUsernameInBuddyList(client.username);
    }

    public static async openClientByUserdata(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
        ClientUserdataStore.set(client);
        try {
            await this.routeToClient(client);
        } catch (e) {

        }
    }

    public static getUserdataFieldOptionsWithIcons(userdata?: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
        let result: BuddyListOptionWithIcon[] = [];
        if (userdata) {
            let options = OperatorAccountStore.optionsWithIconBySite.value[userdata.siteId];
            if (options) {
                let fields = userdata.fields;
                for (let fieldName in fields) {
                    if (fields.hasOwnProperty(fieldName)) {
                        if (options[fieldName]) {
                            let values = Array.isArray(fields[fieldName]) ? fields[fieldName] : [fields[fieldName]];
                            for (let value of values) {
                                if (value) {
                                    let option = options[fieldName].options[value.toString()];
                                    if (option) {
                                        let field: OperatorApplicationApi.AbstractFormElementOpenApiModel = options[fieldName].field;
                                        result.push({
                                            tooltip: `${field.descr}: ${option.descr}`,
                                            option
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return result;
    }

}

OperatorApplicationEventManager.addEventListener(NEW_HAVE_NO_ANSWER_CLIENT, async (client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) => {
    if (OperatorApplicationConfigInstance.offlineQuestionsNotificationsEnabled) {
        OperatorApplicationPlatform.notifications.show({
            title: __("Клиент ожидает ответа"),
            text: __("Ожидающие ответа посетители помечены в списке знаками вопроса."),
            groupId: "haveNoAnswer",
            click: () => {
                OperatorApplicationBuddyList.addClientAndOpenByUsername(client.username);
            }
        });
    }
    try {
        await Delay.make(100, "offlineQuestionSoundNotify", true);
        playNotificationSoundAboutClientMessage(client, true, true);
    } catch (e) {

    }
})

OperatorApplicationEventManager.addEventListener(ADD_AND_OPEN_CLIENT_BY_USERNAME, (p: AddAndOpenClientByUsernamePayloadInterface) => {
    OperatorApplicationBuddyList.addClientAndOpenByUsername(p.username, p.messageId, p.dialogId);
})